const ItemsAffected = Object.freeze({
  One: 1,
  All: 2,
  Custom: 3,
});

export default ItemsAffected;
